import { accountKitApi, accountKitReducer } from "@nerdjs/account-kit";
import { networkMiddleware, networkReducer } from "@nerdjs/nerd-network";
import { notificationReducer } from "@nerdjs/nerd-ui";
import { combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { configureStore } from "@reduxjs/toolkit";
import { mainMiddleware } from "./mainMiddleware";

const rootReducer = combineReducers({
  accountKitState: accountKitReducer,
  notification: notificationReducer,
  networkState: networkReducer,
  [accountKitApi.reducerPath]: accountKitApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    thunkMiddleware,
    mainMiddleware,
    accountKitApi.middleware,
    networkMiddleware, // Always add networkMiddleware after your api middleware
  ],
});

export type AppDispatch = typeof store.dispatch;
